module.exports = __webpack_public_path__ + "static/media/indoor-outdoor-secondary.d8308b69.jpg";